import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsx("polygon", {
		className: "icon-fill-primary",
		points: "45 45 0 45 0 15 8.2 15 8.2 17.5 2.5 17.5 2.5 42.5 42.5 42.5 42.5 17.5 36.9 17.5 36.9 15 45 15"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M22.5 0C13.8 0 7 3.7 7 8.4v19.5c0 4.7 6.8 8.4 15.5 8.4S38 32.5 38 27.8V8.4C38 3.7 31.2 0 22.5 0zm0 2.5c7.7 0 13 3.1 13 5.9 0 .6-.3 1.2-.7 1.8-1.8-2.8-6.5-4.7-12.3-4.7-5.8 0-10.5 1.9-12.3 4.7-.5-.6-.7-1.2-.7-1.8 0-2.8 5.3-5.9 13-5.9zm10.4 9.3c-2.3 1.4-6 2.4-10.4 2.4s-8.1-1-10.4-2.4C13 9.9 17 8 22.5 8s9.5 1.9 10.4 3.8zm2.6 16c0 2.8-5.4 5.9-13 5.9s-13-3.1-13-5.9v-.1c2.7 2.6 7.5 4.3 13 4.3s10.3-1.7 13-4.3v.1zm-13 1.7c-7.1 0-13-3.2-13-7V13c2.7 2.3 7.5 3.8 13 3.8s10.3-1.5 13-3.8v9.5c0 3.8-5.9 7-13 7z"
	})]
});
export default SvgIcon;
